<template>
  <section class="detail">
    <div class="container">
      <a-typography-title :level="1">
        星汉未来智能运维解决方案
      </a-typography-title>
      <a-typography-paragraph>
        基于业务指标的监控及精准度量能力，<br>
        对AWS、阿里云等各个云平台上的基础设施、各类算力进行统一管理及极速调度，实现业务的快速发布部署、各个业务间的算力共享。<br>
        通过决策支持平台全面展示业务全景信息，并提供专业的决策建议和决策动作入口，大幅提升运维决策效率及合理性。
      </a-typography-paragraph>
      <div class="box_image">
        <img alt=""
             :src="$Store.Public().isGridMatch('>=',$Enum.GridEnum.MD)?file.ImagePC:file.ImageMobile" />
      </div>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';
import ImagePC from '@resource/image/page/planOperation/detail_image_pc.png';
import ImageMobile from '@resource/image/page/planOperation/detail_image_mobile.png';

export default {
  name: 'plan_detail',
  data(): DataInterface {
    return {
      file: {
        ImagePC,
        ImageMobile
      }
    };
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@imagePublic: '@{src_image}page/public/';
@image: '@{src_image}page/planOperation/';

.detail {
  overflow: hidden;
  position: relative;
  padding: 0 @padding;
  .bg('@{imagePublic}bg_1.jpg');
  background-size: cover;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    padding: @space 0;
    margin: 0 auto;
    .borderBox();
  }
}

h1.ant-typography {
  margin: 0;
  .font(center, @title, @color_12, @title, true);
}

div.ant-typography {
  margin: @margin_mo 0 0;
  .font(center, @text+@line, @color_13, @text);
}

.box_image {
  position: relative;
  padding: 20px;
  margin: @margin_mo 0 0;
  background: @color_white;
  border-radius: 10px;
  
  img {
    display: block;
    width: 100%;
  }
}

@media screen and (max-width: -1px+@grid_md) {
  .detail {
    .container {
      padding: @space_mo 0;
    }
  }
  
  h1.ant-typography {
    .font(center, @title_mo+@line_mo, @color_12, @title_mo, true);
  }
  
  div.ant-typography {
    .font(justify, @text_mo+@line_mo, @color_13, @text_mo);
  }
  
  .box_image {
    img {
    
    }
  }
}
</style>